document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('component-swiper')) {
    class SwiperSlideShow extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        const root = this;

        this.swiperPrev = root.querySelector('.swiper-button-prev');
        this.swiperNext = root.querySelector('.swiper-button-next');
        this.swiperPagination = root.querySelector('.swiper-pagination');
        this.swiperContainer = root.querySelector('.swiper-container');
        this.swiperScrollbar = root.querySelector('.swiper-scrollbar');
        this.swiperSlides = root.querySelectorAll('.swiper-slide');

        this.slideshowSwiper = undefined;
        this.resizeObserver = null;
        this.resizeHandler = null;
      }

      connectedCallback() {
        if (this.initialized || !this.swiperContainer) return;
        this.initSwiper();
        this.allowTouchMove();
        this.addResizeListener();
        this.initialized = true;
      }

      disconnectedCallback() {
        this.removeResizeListener();
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') {
          console.error('Swiper is not defined.');
          return;
        }

        const swiperOptions = {};

        if (this.swiperNext && this.swiperPrev) {
          swiperOptions.navigation = {
            nextEl: this.swiperNext,
            prevEl: this.swiperPrev,
          };
        }

        if (this.swiperPagination) {
          swiperOptions.pagination = {
            el: this.swiperPagination,
          };
        }

        if (this.swiperScrollbar) {
          swiperOptions.scrollbar = {
            el: this.swiperScrollbar,
          };
        }

        let swiperSettings = {};
        try {
          const settingsAttr = this.getAttribute('data-settings');
          if (settingsAttr) {
            swiperSettings = JSON.parse(settingsAttr);
          }
        } catch (e) {
          console.warn('Invalid data-settings JSON:', e);
        }

        const finalOptions = Object.assign({}, swiperSettings, swiperOptions);

        this.slideshowSwiper = new Swiper(this.swiperContainer, finalOptions);
      }

      allowTouchMove() {
        if (!this.slideshowSwiper || !this.slideshowSwiper.slides) return;

        const { slidesPerView, slides } = this.slideshowSwiper;

        if (
          typeof slidesPerView !== 'number' ||
          !Array.isArray(slides)
        ) return;

        const shouldDisableTouch = () => {
          return window.innerWidth > 850 &&
            Number.isFinite(slidesPerView) &&
            slides.length >= 0 &&
            slidesPerView === slides.length;
        };
        console.log(shouldDisableTouch());
        if (this.slideshowSwiper) {
          this.slideshowSwiper.allowTouchMove = !shouldDisableTouch();
        }
      }

      addResizeListener() {
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(() => {
            this.allowTouchMove();
          });
          this.resizeObserver.observe(document.body);
        } else {
          this.resizeHandler = () => {
            this.allowTouchMove();
          };
          window.addEventListener('resize', this.resizeHandler);
        }
      }

      removeResizeListener() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
          this.resizeHandler = null;
        }
      }
    }

    customElements.define('component-swiper', SwiperSlideShow);
  }
});